import { props } from 'cerebral/tags'
import { when } from 'cerebral/operators'
import hideTreeContextMenu from './hideTreeContextMenu'
import initNodePanel from '../actions/initNodePanel'
import getNode from '../actions/getNode'

export default [
  ...hideTreeContextMenu,
  when(props`path`),
  {
    true: [getNode],
    false: []
  },
  initNodePanel
]



// WEBPACK FOOTER //
// ./src/modules/Node/chains/showNodePanel.js